'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';

/**
 * Importación de las Actions.
 */
import {
    INITIAL_STATE_SALDOS_RESUMENES,
    GET_DATA_SALDOS_RESUMENES,
    RECEIVE_DATA_SALDOS_RESUMENES,
    GET_CUENTA_CORRIENTE_DATA,
    GET_CUOTAS_PENDIENTES_SALDOS_RESUMENES,
    CLOSE_MODAL_CP_SALDOS_RESUMENES
} from '../../Screens/SaldosResumenes/actions/SaldosResumenesActions';

/**
 * Estado inicial.
 */
const initialState = {
    data: {
        cuenta: undefined,
        fechasCierres: undefined,
        detalleCC: undefined,
        saldosCierre: undefined,
        pagos: undefined,
        consumos: undefined,
        cuotas: undefined,
        ajustes: undefined,
        saldosTotales: undefined,
        ultimoCierre: undefined,
        proximoResumen: undefined,
        resumenAnterior: undefined,
        limiteDisponible: undefined,
        fechasCierreUltimaCartera: undefined,
        detalleCuenta: undefined,
        pagosRegistradosPesos: undefined,
        isLoading: true,
        cuentaCorriente: null,
        modalTotalCuotasPendientes: false
    }
};

function saldosResumenes(state = initialState, action) {
    LogHelper.In(saldosResumenes.name, state, action);

    switch (action.type) {

        case INITIAL_STATE_SALDOS_RESUMENES:
            return initialState;

        case GET_DATA_SALDOS_RESUMENES:
            return initialState

        case RECEIVE_DATA_SALDOS_RESUMENES:

            return {
                ...state,
                data: {
                    ...state.data,
                    cuenta: action.data.cuenta,
                    fechasCierres: action.data.fechasCierres,
                    saldosCierre: action.data.saldosCierre,
                    pagos: action.data.pagos,
                    consumos: action.data.consumos,
                    cuotas: action.data.cuotas,
                    ajustes: action.data.ajustes,
                    saldosTotales: action.data.saldosTotales,
                    ultimoCierre: action.data.ultimoCierre,
                    proximoResumen: action.data.proximoResumen,
                    resumenAnterior: action.data.resumenAnterior,
                    limiteDisponible: action.data.limiteDisponible,
                    fechasCierreUltimaCartera: action.data.fechasCierreUltimaCartera,
                    pagosRegistradosPesos: action.data.pagosRegistradosPesos,
                    pagosRegistradosDolares: action.data.pagosRegistradosDolares,
                    isLoading: false
                }
            };

        case GET_CUOTAS_PENDIENTES_SALDOS_RESUMENES:

            return {
                ...state,
                data: {
                    ...state.data,
                    cuentaCorriente: {
                        ...state.data.cuentaCorriente,
                        cuotasPendientesPesos: action.data.cuotasPendientesPesos,
                        totalCuotasPendientesPesos: action.data.totalCuotasPendientesPesos,
                        cuotasPendientesDolares: action.data.cuotasPendientesDolares,
                        totalCuotasPendientesDolares: action.data.totalCuotasPendientesDolares,
                        fechasCierresConsumos: action.data.fechasCierresConsumos,
                        tarjetasCreditoId: action.data.tarjetasCreditoId,
                    },
                    modalTotalCuotasPendientes: true,
                    isLoading: false
                }
            }

        case CLOSE_MODAL_CP_SALDOS_RESUMENES:

            return {
                ...state,
                data: {
                    ...state.data,
                    modalTotalCuotasPendientes: false
                }
            }

        case GET_CUENTA_CORRIENTE_DATA:
            if (state.data.cuentaCorriente && action.ejecutarSP) {
                /*gracias a IE se tiene que armar de esta manera, se ponen los push y luego se ordena*/
                (action.fechasCierre || []).forEach(fc => {
                    state.data.cuentaCorriente.fechasCierreCC.push(fc);
                });

                state.data.cuentaCorriente.fechasCierreCC = state.data.cuentaCorriente.fechasCierreCC.sort((a, b) => new Date(a.FechaCierre) - new Date(b.FechaCierre));

                (action.data.consumosTarjetas || []).forEach(ct => {
                    state.data.cuentaCorriente.consumosTarjetas.push(ct);
                });

                (action.data.montoTotales || []).forEach(mt => {
                    state.data.cuentaCorriente.montoTotales.push(mt);
                });

                (action.data.cuotasPendientesTotales || []).forEach(cpt => {
                    state.data.cuentaCorriente.cuotasPendientesTotales.push(cpt);
                });

                return {
                    ...state,
                    data: {
                        ...state.data,
                        isLoading: false
                    }
                }
            }

            return {
                ...state,
                data: {
                    ...state.data,
                    cuentaCorriente: action.data,
                    isLoading: false
                }
            }

        default:
            return state;
    }
}

export default saldosResumenes;